import React from 'react';
import {
  Button,
  Icon
} from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';


const ButtonSecondary = withStyles({
  root: {
    background: '#F0F0FF',
    border: '1px solid #D9D8FF',
    borderRadius: '4px'
  }
})(Button);

const AddMembershipButton = ({
  setOpenAddingMembershipsDialog
}) => {
  return (
    <>
      <ButtonSecondary
        variant="outlined"
        color="primary"
        className="px-6 font-bold"
        onClick={() => setOpenAddingMembershipsDialog(true)}
      >
        <span className="flex items-center">
          <Icon className="mr-2">add</Icon>
          <span className="mt-1">Add Membership Subscription Options</span>
        </span>
      </ButtonSecondary>
    </>
  );
};

export default AddMembershipButton;
